import MobileHeader from '../../components/mobile/MobileHeader';
import MobileLoginForm from '../../components/mobile/MobileLoginForm';
import MobileBottomNav, { type NavItem } from '../../components/mobile/MobileBottomNav';

const MobileLoginPage = () => {
  // Create nav items (no badge needed on login page)
  const navItems: NavItem[] = [
    {
      id: 'home',
      label: '首頁',
      path: '/',
      icon: '🏠',
    },
    {
      id: 'ads',
      label: '廣告',
      path: '/ads',
      icon: '🛒',
    },
    {
      id: 'wish',
      label: '願望',
      path: '/wishes',
      icon: '⭐',
    },
    {
      id: 'profile',
      label: '會員',
      path: '/member',
      icon: '👤',
    },
  ];

  return (
    <div>
      <MobileHeader title="會員登入" showBack={false} />
      <MobileLoginForm />
      <MobileBottomNav items={navItems} />
    </div>
  );
};

export default MobileLoginPage;
